module.exports = __webpack_public_path__ + "static/img/newsbb.c005de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsbb.png
// module id = iIZ7
// module chunks = 45